import {EditorState, Modifier, SelectionState} from 'draft-js';

export interface MergeTag {
	token: string;
	label: string;
}

export const MERGE_TAGS: MergeTag[] = [
	{token: 'firstname', label: 'First Name'},
	{token: 'lastname', label: 'Last Name'},
	{token: 'email', label: 'Email'},
	{token: 'company', label: 'Company'},
	{token: 'title', label: 'Subject'},
	{token: 'ticketid', label: 'Ticket ID'},
];

export function insertMergeTag(editorState: EditorState, tag: MergeTag): EditorState {
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();

	const contentWithEntity = content.createEntity('MERGE_TAG', 'IMMUTABLE', {
		token: tag.token,
		label: tag.label,
	});
	const entityKey = contentWithEntity.getLastCreatedEntityKey();

	const contentWithTag = Modifier.replaceText(contentWithEntity, selection, tag.label, undefined, entityKey);

	const blockKey = selection.getAnchorKey();
	const offset = selection.isCollapsed()
		? selection.getAnchorOffset() + tag.label.length
		: selection.getStartOffset() + tag.label.length;

	const afterTagSelection = SelectionState.createEmpty(blockKey).merge({
		anchorOffset: offset,
		focusOffset: offset,
	}) as SelectionState;

	const contentWithSpace = Modifier.insertText(contentWithTag, afterTagSelection, ' ');

	const newEditorState = EditorState.push(editorState, contentWithSpace, 'insert-characters');

	const finalSelection = SelectionState.createEmpty(blockKey).merge({
		anchorOffset: offset + 1,
		focusOffset: offset + 1,
	}) as SelectionState;

	return EditorState.forceSelection(newEditorState, finalSelection);
}
